import { render } from "./productModel.vue?vue&type=template&id=1ffb5876&scoped=true"
import script from "./productModel.vue?vue&type=script&lang=js"
export * from "./productModel.vue?vue&type=script&lang=js"

import "./productModel.vue?vue&type=style&index=0&id=1ffb5876&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffb5876"]])

export default __exports__